import React from 'react'
import { useSelectedColumns } from './ColumnsFilter/useSelectedColumns'
import { useCompanyDetailContextValue } from '../../../context/CompanyDetailProvider'
import { PaginatedTable } from 'components/Table/PaginatedTable'

export const ShiftsTable = () => {
  const {
    state: {
      shifts: { data, pagination, isFetching },
    },
    actions: {
      shifts: { setPagination },
    },
  } = useCompanyDetailContextValue()

  const columns = useSelectedColumns()
  return (
    <PaginatedTable
      columns={columns}
      items={data.items}
      rowCount={data.totalRows}
      pagination={pagination}
      setPagination={setPagination}
      isFetching={isFetching}
      emptyMessage="No shifts matched your search. Try using different filters."
      emptyStateMaxWidth={['100%', '100%', '50%', '50%']}
      // FIX ME: stickyHeader's z-index is set to 1, which collides with the z-index of the AttributesSelector. We should bump AttributesSelector's z-index to 2.
      // stickyHeader
    />
  )
}
